<template>
    <div
        class="
          top-0 z-20 flex gap-3 overflow-y-auto overflow-x-scroll bg-white px-6 pb-[16px] text-xs

          lg:sticky lg:m-0 lg:w-[124px] lg:min-w-[124px] lg:flex-col lg:overflow-x-hidden lg:px-8 lg:pb-[34px] lg:pt-[64px]

          sm:mb-[16px] sm:pt-[24px]
        "
    >
        <primary-button
            v-for="button in buttons"
            :key="button.step"
            :button="button"
            :is-active="currentStep === button.step"
            :size-in-px="64"
            :aria-label="getPlainText(button.label)"
            @click="setCurrentStep(button.step)"
        >
            <component :is="button.icon" />
        </primary-button>
    </div>
</template>

<script>
    import allStores from '../stores/all';
    import WalletIcon from './icons/WalletIcon.vue';
    import GroupsIcon from './icons/GroupsIcon.vue';
    import ImageIcon from './icons/ImageIcon.vue';
    import TextFieldsIcon from './icons/TextFieldsIcon.vue';
    import AbcIcon from './icons/AbcIcon.vue';
    import PrimaryButton from './UI/buttons/PrimaryButton.vue';
    import {
        STEP_WALLET,
        STEP_BULK_ORDER,
        STEP_ICONS,
        STEP_TEXT,
        STEP_MONOGRAM,
    } from '../constants';

    export default {
        mixins: [allStores],

        data() {
            return {
                STEP_WALLET,
                STEP_BULK_ORDER,
                STEP_ICONS,
                STEP_TEXT,
                STEP_MONOGRAM,
            };
        },

        components: {
            PrimaryButton,
            WalletIcon,
            GroupsIcon,
            ImageIcon,
            TextFieldsIcon,
            AbcIcon,
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            currentStep() {
                return this.appStore.currentStep;
            },

            anyIconOptions() {
                return this.customizerStore.anyIconOptions;
            },

            anyTextOptions() {
                return this.customizerStore.anyTextOptions;
            },

            anyMonogramOptions() {
                return this.customizerStore.anyMonogramOptions;
            },

            buttons() {
                const list = [];

                const productStepName = this.viewController?.blueprint?.groups?.find((g) => g.code === 'Product')?.name;

                list.push({
                    step: STEP_WALLET,
                    icon: 'WalletIcon',
                    label: productStepName,
                });

                if (this.anyIconOptions) {
                    list.push({
                        step: STEP_ICONS,
                        icon: 'ImageIcon',
                        label: this.$t('STEP_ICONS'),
                    });
                }

                if (this.anyTextOptions) {
                    list.push({
                        step: STEP_TEXT,
                        icon: 'TextFieldsIcon',
                        label: this.$t('STEP_TEXT'),
                    });
                }

                if (this.anyMonogramOptions) {
                    list.push({
                        step: STEP_MONOGRAM,
                        icon: 'AbcIcon',
                        label: this.$t('STEP_MONOGRAM'),
                    });
                }

                list.push({
                    step: STEP_BULK_ORDER,
                    icon: 'GroupsIcon',
                    label: this.$t('STEP_BULK_ORDERING'),
                });

                return list;
            },
        },

        methods: {
            setCurrentStep(step) {
                this.appStore.setCurrentStep(step);
            },

            getPlainText(html) {
                return html.replace(/<[^>]*>/g, ' ');
            },
        },
    };
</script>
